import { types, flow } from 'mobx-state-tree';
import { query } from '../core/createApolloClient/createApolloClient.client';
import { getp } from '../helpers/getProp';
import gql from 'graphql-tag';

export default types
  .model('UserModel', {
    id: '',
    createdAt: types.Date,
    lat: '',
    lng: '',
    isEmailVerified: false,
    isOnboarded: false,
    appInstalled: false,
    profilePhoto: '',
    firstName: '',
    email: '',
    isFacebookConnected: false,
    isGoogleConnected: false,
    isIdVerification: false,
    isPhoneVerified: false,
    loading: true,
  })
  .actions(self => {
    return {
      login: (userId, userAccount) => {
        if (!userId) {
          self.loading = false;
          //false means we tried to log in, but no user
          return;
        }
        console.log('LOGIN', userId, 'user account: ', !!userAccount);
        self.id = userId;
        if (userAccount) {
          self.isEmailVerified = userAccount.isEmailConfirmed;
          self.isOnboarded = userAccount.isOnboarded;
          self.appInstalled = userAccount.appInstalled;
          self.isFacebookConnected =
            userAccount.isFacebookConnected;
          self.isGoogleConnected = userAccount.isGoogleConnected;
          self.isIdVerification = userAccount.isIdVerification;
          self.isPhoneVerified = userAccount.isPhoneVerified;
          self.profilePhoto = userAccount.picture || '';
          self.firstName = userAccount.firstName;
          self.email = userAccount.email;
        }
        self.loading = false;
      },
      logout: () => {
        self.id = '';
        self.firstName = '';
        self.email = '';
      },
      updateValidPhone: phone => {
        self.phoneNumber = phone;
        self.isPhoneVerified = true;
      },
      setLocation: (lat, lng) => {
        self.lat = lat ? lat : '0.0';
        self.lng = lng ? lng : '0.0';
      },
      setPhoto: photo => {
        self.profilePhoto = photo || '';
      },
      refreshVerification: flow(function*() {
        const results = yield query(
          gql`
            query getUserInfo($userId: String!) {
              getUserVerifiedInfo(userId: $userId) {
                isOnboarded
                isEmailConfirmed
                isFacebookConnected
                isGoogleConnected
                isIdVerification
                isPhoneVerified
              }
            }
          `,
          { userId: self.id },
          {
            fetchPolicy: 'network-only',
          },
        );
        const valid = getp(results, 'data.getUserVerifiedInfo');
        if (valid) {
          self.isOnboarded = valid.isOnboarded;
          self.isEmailVerified = valid.isEmailConfirmed;
          if (valid.isEmailConfirmed) {
            return true;
          }
        }
        return false;
      }),
    };
  })
  .views(self => ({
    get isLoggedIn() {
      return !!self.id;
    },
    get needsOnboarding() {
      return !self.isOnboarded;
    },
    get needsVerification() {
      return !self.isPhoneVerified || !self.profilePhoto;
    },
    get verificationCount() {
      let vCount = 0;
      if (self.isEmailVerified) vCount++;
      if (self.isPhoneVerified) vCount++;
      if (self.isIdVerification) vCount++;
      return vCount;
    },
  }));



// WEBPACK FOOTER //
// ./src/mobxStores/UserModel.js